/* tslint:disable:typedef-whitespace align no-trailing-whitespace */

import { Action, ActionType    } from '@/models/action';
import { Project }               from '@/models/project';
import { ProjectService        } from "@/services/project.service";

/**
 *
 * @class ProjectRenameAction
 *
 * @brief change current name of a project
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      March 2020
 *
 */
export class ProjectRenameAction extends Action {

  private projects: ProjectService    = null;

  constructor(options: any = null) {

    super({
      key:   'project.rename',
      type:  ActionType.Project_Rename,
      label: 'Rename',
      icon:  '<i class="fas fa-tag"></i>',
      tip:   'Change the name of the project'
    });

    this.projects = this.injector().get(ProjectService);
  }

  /* is this action enabled? */
  public enabled(): boolean {

    return true;
  }

  /** implement the action */
  public execute(): boolean {

    if (!this.enabled()) {
      return false;
    }

    const project: Project        = this.projects.project();

    project.renameProject();

    return true;
  }
}
